var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lad-ask-question"},[_c('el-header',{staticClass:"lad-ask-question--header",attrs:{"align":"center"}},[_c('h2',[_vm._v(_vm._s(_vm.success ? _vm.$t(`${_vm.base}.success.title`) : _vm.$t(`${_vm.base}.title`)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }